import React from 'react'
import rightArrow from '../../../assets/right-arrow.svg'
import leftArrow from '../../../assets/left-arrow.svg'

const SecondStep = ({ formData, setFormData, nextStep, prevStep }) => {
    return (
        <>
            <h3 className='step-header'>My personal need is to:</h3>
            <div className='form-container'>
                <div>
                    <input className='step-input' type="radio" id="form-nepal-study" name="drone" value="form-nepal-study" />
                    <label className='step-label' for="form-nepal-study"> Study In Nepal  </label>
                </div>
                <div>
                    <input className='step-input' type="radio" id="form-abroad-study" name="drone" value="form-abroad-study" />
                    <label className='step-label' for="form-abroad-study">Study Abroad  &#127760;</label>
                </div>

            </div>
            <div className='step-img-container'>
                <img onClick={prevStep} className='step-img' src={leftArrow} alt='right' />
                <img onClick={nextStep} className='step-img' src={rightArrow} alt='right' />
            </div>
        </>
    );
}

export default SecondStep